import type { ItemStoreState } from "@editor/items/ItemStore";

export function migrateSimulation_3_5(
  simulation: OldSimulationItem | NewSimulationItem,
  modelState: { actions?: ItemStoreState<OldActionItem | NewActionItem> }
) {
  for (const round of simulation.rounds) {
    for (const activation of round.activatedActions) {
      const newCosts: { [elementUid: string]: number } = {};
      for (const [resourceId, cost] of Object.entries(activation.costs)) {
        if (cost == null) continue; // Skip null and undefined costs
        if (resourceId.includes("_")) continue; // Already migrated
        newCosts[`resource_${resourceId}`] = cost;
      }
      activation.costs = newCosts;
    }

    for (const [actionId, unpayableAction] of Object.entries(
      round.notPayableActions
    )) {
      if (unpayableAction.elementUid) continue; // Already migrated
      const action = modelState.actions?.items[parseInt(actionId)];
      const uid = `resource_${unpayableAction.resourceId}` as const;

      let neededValue = 0;
      if (action) {
        if (!Array.isArray(action.costs)) {
          neededValue = action.costs[unpayableAction.resourceId];
        }
      }

      round.notPayableActions[parseInt(actionId)] = {
        elementUid: uid,
        actionId: unpayableAction.actionId,
        availableValue: unpayableAction.availableValue,
        neededValue
      };
    }
  }
}

type NewSimulationItem = {
  id: number;
  type: "simulation";
  uid: string;
  createdAt: number;
  rounds: NewSimulationRoundItem[];
};
type NewSimulationRoundItem = {
  index: number;
  activatedActions: NewActionActivation[];
  notPayableActions: {
    [actionId: number]: NewUnpayableAction;
  };
};
type NewActionActivation = {
  actionId: number;
  costs: { [elementUid: string]: number };
};
type NewUnpayableAction = {
  elementUid: `resource_${number}` | `target_${number}`;
  actionId: number;
  availableValue: number;
  neededValue: number;
};
type OldSimulationItem = {
  id: number;
  type: "simulation";
  uid: `simulation_${number}`;
  createdAt: number;
  rounds: OldSimulationRoundItem[];
};
type OldSimulationRoundItem = {
  index: number;
  activatedActions: OldActionActivation[];
  notPayableActions: {
    [actionId: number]: OldUnpayableAction;
  };
};
type OldActionActivation = {
  actionId: number;
  costs: { [resourceId: string]: number };
};
type OldUnpayableAction = {
  resourceId: number;
  actionId: number;
  availableValue: number;
};

type OldActionItem = {
  id: number;
  type: "action";
  uid: `action_${number}`;
  costs: { [resourceId: number]: number };
  createdAt: number;
};
type NewActionItem = {
  id: number;
  type: "action";
  uid: `action_${number}`;
  costs: { elementUid: string; expression: string }[];
  createdAt: number;
};
